import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { useOutletContext } from 'react-router-dom-v5-compat';
import { compose } from 'redux';

import type { FormJobOutletContext } from 'af-root/scenes/Company/Jobs/Form/types';

import { isAllowed } from '@acceligentllc/shared/utils/auth';

import type { RootState } from 'af-reducers';

import PagePermissions from 'ab-enums/pagePermissions.enum';

import { JOB_CREATE, JOB_EDIT } from 'af-constants/reduxForms';

import DirectoriesAttachments from 'af-components/SharedForms/Job/Details/Attachments/DirectoriesAttachments';

import { formSectionClass, formSectionClassColumn8, formSectionClassRow } from './helpers';

type Props = ConnectedProps<typeof connector>;

const AttachmentsTab: React.FC<Props> = (props) => {
	const { hasManageJobPermission } = props;

	const { change, workRequestId } = useOutletContext<FormJobOutletContext>();

	const formName = workRequestId
		? JOB_EDIT
		: JOB_CREATE;

	return (
		<div className={formSectionClass}>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn8}>
					<DirectoriesAttachments change={change} formName={formName} isDisabled={!hasManageJobPermission} jobId={workRequestId ?? null} />
				</div>
			</div>
		</div>
	);
};

function mapStateToProps(state: RootState) {
	const { user: { companyData, userData } } = state;
	if (!userData || !companyData) {
		throw new Error('User not logged in');
	}

	const hasManageJobPermission = isAllowed(PagePermissions.COMPANY.JOBS.MANAGE_JOBS, companyData.permissions, companyData.isCompanyAdmin, userData.role);

	return {
		hasManageJobPermission,
	};
}

const connector = connect(mapStateToProps, null);

const enhance = compose<React.ComponentType>(
	React.memo,
	connector
);

export default enhance(AttachmentsTab);
